import { Controller } from "@hotwired/stimulus";
import { dispatchUnexpectedErrorOccurred } from "../events/erroroccurred";
import { parseJsonResponse } from "../http_helpers";
export default class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.settingValue = "";
    }
    async connect() {
        const setting = await this.fetchSetting();
        if (setting) {
            this.settingValue = setting.value;
            this.displaySettingValue(setting);
        }
    }
    prepareFetch() {
        this.loadingPlaceholderTargets.forEach((e) => e.classList.remove(this.hiddenClass));
        this.valueContainerTargets.forEach((e) => e.classList.add(this.hiddenClass));
        this.valueControlTarget.disabled = true;
        return () => {
            this.loadingPlaceholderTargets.forEach((e) => e.classList.add(this.hiddenClass));
            this.valueContainerTargets.forEach((e) => e.classList.remove(this.hiddenClass));
            this.valueControlTarget.disabled = false;
        };
    }
    async fetchSetting() {
        const done = this.prepareFetch();
        let json;
        try {
            json = await parseJsonResponse(this, await window.fetch(this.fetchUrlValue));
        }
        catch (error) {
            dispatchUnexpectedErrorOccurred(this, error);
        }
        finally {
            done();
        }
        if (typeof json === undefined) {
            return;
        }
        return this.parseSetting(json?.data);
    }
    displaySettingValue(setting) {
        if (this.valueControlTarget.type === "checkbox") {
            this.valueControlTarget.checked = setting.value === "1";
            this.valueControlTarget.labels?.forEach((l) => (l.textContent = this.valueControlTarget.checked
                ? "Habilitado"
                : "Deshabilitado"));
        }
        else {
            this.valueControlTarget.value = setting.value;
        }
    }
    async updateSetting() {
        const done = this.prepareFetch();
        const input = this.valueControlTarget;
        const setting = this.parseSetting({
            name: input.name,
            value: input.type === "checkbox" ? (input.checked ? "1" : "0") : input.value,
        });
        let json;
        try {
            json = await parseJsonResponse(this, await window.fetch(this.updateUrlValue, {
                method: "POST",
                body: new URLSearchParams({
                    "setting[name]": setting.name,
                    "setting[value]": setting.value,
                }),
            }));
        }
        catch (error) {
            dispatchUnexpectedErrorOccurred(this, error);
        }
        finally {
            done();
        }
        if (typeof json === "undefined") {
            if (input.type === "checkbox") {
                input.checked = this.settingValue === "1";
            }
            else {
                input.value = this.settingValue;
            }
            return;
        }
        this.settingValue = setting.value;
        this.displaySettingValue(setting);
    }
    parseSetting(data) {
        const setting = {
            id: 0,
            companyId: 0,
            companyUsername: "",
            name: "",
            value: "",
        };
        if (typeof data === "object") {
            if (typeof data.id === "number") {
                setting.id = data.id;
            }
            if (typeof data.companyId === "number") {
                setting.companyId = data.companyId;
            }
            if (typeof data.companyUsername === "string") {
                setting.companyUsername = data.companyUsername;
            }
            if (typeof data.name === "string") {
                setting.name = data.name;
            }
            if (typeof data.value === "string") {
                setting.value = data.value;
            }
        }
        return setting;
    }
}
default_1.classes = ["hidden"];
default_1.targets = ["loadingPlaceholder", "valueContainer", "valueControl"];
default_1.values = {
    fetchUrl: String,
    updateUrl: String,
};
//# sourceMappingURL=settings_updater_controller.js.map